import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import get from 'lodash.get';
import styles from './PdpSharedPromoCode.scss';
import classnames from 'classnames';
import {
    TRADE_WELCOME_PROMO_CODE,
    TRADE_FIRST_WELCOME_PROMO_CODE,
} from 'dibs-buyer-layout/exports/tradePromoConstants';

import { PromoCodeLoader } from '../../global/PromoCodeLoader';
import { TradePromoLoader } from '../../global/TradePromo/TradePromoLoader';

export const PdpSharedPromoCodeComponent = ({
    user,
    userId,
    itemId,
    displayInfo,
    relay,
    onlyShippingPromos,
    excludeShippingPromos,
}) => {
    if ((!displayInfo && !onlyShippingPromos) || !userId) {
        return null;
    }

    const tradeFirm = get(user, 'tradeFirm');
    const userLevelPromo = get(user, 'activePromotion');
    const userLevelPromoCode = get(userLevelPromo, 'code');
    const hasFirmLevelPromo = get(tradeFirm, 'rewards.currentPromoSegment.segmentCode');
    const hasTradeUserPromo = [TRADE_WELCOME_PROMO_CODE, TRADE_FIRST_WELCOME_PROMO_CODE].includes(
        userLevelPromoCode
    );

    // if there is no user-level promo, render this for trade users so points-earned messaging appears
    if (hasTradeUserPromo || (tradeFirm && (hasFirmLevelPromo || !userLevelPromo))) {
        return <TradePromoLoader user={user} />;
    }

    const showSalePrice = get(displayInfo, 'pricing.showSale');
    const showNetPrice = get(displayInfo, 'pricing.showNet');

    const containerClass = classnames(styles.container, {
        [styles.onlyShippingPromosContainer]: onlyShippingPromos,
    });

    return (
        <PromoCodeLoader
            load
            environment={relay.environment}
            userId={userId}
            itemId={itemId}
            isFurtherReduced={showSalePrice || showNetPrice}
            containerClass={containerClass}
            displaySingleLine
            hideDetails
            onlyShippingPromos={onlyShippingPromos}
            excludeShippingPromos={excludeShippingPromos}
        />
    );
};

PdpSharedPromoCodeComponent.propTypes = {
    user: PropTypes.object,
    userId: PropTypes.string,
    item: PropTypes.object,
    itemId: PropTypes.string,
    displayInfo: PropTypes.object,
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object,
    onlyShippingPromos: PropTypes.bool,
    excludeShippingPromos: PropTypes.bool,
};

PdpSharedPromoCodeComponent.defaultProps = {
    displayInfo: {},
};

export const PdpSharedPromoCode = createFragmentContainer(PdpSharedPromoCodeComponent, {
    displayInfo: graphql`
        fragment PdpSharedPromoCode_displayInfo on ItemDisplayInfo {
            pricing {
                showSale
                showNet
            }
        }
    `,
    user: graphql`
        fragment PdpSharedPromoCode_user on User {
            activePromotion(itemId: $itemId) {
                code
            }
            ...TradePromo_user @include(if: $isTrade)
            tradeFirm @include(if: $isTrade) {
                rewards {
                    currentPromoSegment(userId: $userId) {
                        segmentCode
                    }
                }
            }
        }
    `,
});
